import styles from './widgetList.module.css'

export type WidgetListRow = {
    key: string
    label: string
    detail?: string
    value: string
    valueKind?: 'default' | 'positive' | 'negative' | 'warning'
    onClick?: () => void
}

type Props = {
    rows: WidgetListRow[]
    ranked?: boolean
    maxRows?: number
}

// Compact list of a dashboard card (rankings, detail lists)
export const WidgetList = (props: Props) => {
    const { rows, ranked, maxRows = 5 } = props
    const visibleRows = rows.slice(0, maxRows)

    return (
        <ul className={styles.list}>
            {visibleRows.map((row, index) => (
                <li
                    key={row.key}
                    className={`${styles.item} ${row.onClick ? styles.clickable : ''}`}
                    onClick={row.onClick}
                >
                    {ranked && <span className={styles.rank}>{index + 1}</span>}
                    <span className={styles.label}>
                        {row.label}
                        {row.detail && <span className={styles.detail}>{row.detail}</span>}
                    </span>
                    <span className={`${styles.value} ${styles[row.valueKind || 'default']}`}>{row.value}</span>
                </li>
            ))}
            {rows.length > maxRows && (
                <li className={styles.more}>+{rows.length - maxRows} más</li>
            )}
        </ul>
    )
}
